import {ErrorMessages} from 'constants/Errors';

import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {removeUnassignedPubEditorAC} from 'pages/pubPagesView/store/pubPageSlice';
import {batch} from 'react-redux';
import {unassignPubEditor} from 'services/pubs';
import {setErrorAC, setSuccessAC} from 'store/app/appSlice';
import {setModalAC} from 'store/modal/modalSlice';
import {setPageEditorUnassignDataAC} from 'store/pubs/pubSlice';

import './UnassignPageEditor.scss';

const UnassignPageEditor = () => {
  const {pageEditorUnassignData} = useGlobalState((state) => state.pubs);
  const dispatch = useSetGlobalState();

  const isLastEditor = pageEditorUnassignData?.pubEditorsListLength === 1;

  const handleCancel = () => {
    batch(() => {
      dispatch(setModalAC(null));
      dispatch(setPageEditorUnassignDataAC(null));
    });
  };

  const handleUnassign = async () => {
    if (!pageEditorUnassignData) return;
    if (isLastEditor) handleCancel();
    else {
      try {
        await unassignPubEditor(pageEditorUnassignData.pubId, pageEditorUnassignData.editorId);

        dispatch(removeUnassignedPubEditorAC(pageEditorUnassignData.editorId));
        dispatch(setSuccessAC('Page editor unassigned successfully'));
      } catch (error) {
        dispatch(setErrorAC(ErrorMessages.UNASSIGN_EDITOR));
      } finally {
        dispatch(setModalAC(null));
      }
    }
  };

  return (
    <div className="unassign-editor">
      <div className="unassign-editor__header">
        <div className="unassign-editor__title">
          <Text tag="span">{isLastEditor ? 'Leaving pub without editors?' : 'Remove editor?'}</Text>
        </div>
      </div>
      <Text tag="p">
        {isLastEditor ? (
          'Please add another editor before you remove the last one. There must be at least one page editor to manage the pub page.'
        ) : (
          <>
            Are you sure you want to remove pub&apos;s page editor <span>{pageEditorUnassignData?.editorName}</span>{' '}
            from <span>{pageEditorUnassignData?.pubName}</span> pub editors page?
          </>
        )}
      </Text>
      <div className="unassign-editor__buttons">
        {!isLastEditor && (
          <Button variant="text" onClick={handleCancel}>
            Cancel
          </Button>
        )}
        {!isLastEditor && <div className="unassign-editor__divider" />}
        <Button variant="primary" onClick={handleUnassign}>
          {isLastEditor ? 'Got it' : 'Remove Editor'}
        </Button>
      </div>
    </div>
  );
};

export default UnassignPageEditor;
